import type { PageIndexChapter2025Data } from '#layers/core/types/content-types'
import type { MapperOptions } from '~/types'
import { mapperBlockContent } from '../../../../core/data-layer/blocks/block-content/mapper-block-content'

/**
 * Block quote mapper
 * @param {Object} data - cms response data
 * @param {Object} options - options
 * @return {Object} the normalized data
 */
export const mapperPageIndexChapterShort = (
  data: PageIndexChapter2025Data,
  options: MapperOptions
): PageIndexChapter2025Data | null => {
  if (!data) {
    return null
  }

  return {
    ...data,
    hero: mapperBlockContent(data.hero, options)
  }
}
